import numeral from 'numeral';

// ----------------------------------------------------------------------

export function fCurrency(number) {
  return numeral(number).format(Number.isInteger(number) ? '$0,0' : '$0,0.00');
}

export function fPercent(number) {
  return numeral(number / 100).format('0.0%');
}
export function fNumber(number) {
  return numeral(number).format();
}

export function fShortenNumber(number) {
  return numeral(number).format('0.00a').replace('.00', '');
}

export function fData(number) {
  return numeral(number).format('0.0 b');
}


// export function formatearNumeroEspPrecision(numeroParametro, precision) {
//   let numero = numeroParametro;
//   const a = parseInt(numero, 10);
//   console.log(a);
//   const b = formatearMiles(a);
//   numero = new Intl.NumberFormat('es-ES').format(parseFloat(numero).toFixed(precision));
//   if (precision > 0) {
//     const decimals = numero.indexOf(',') > -1 ? numero.length - 1 - numero.indexOf(',') : 0;
//     numero = decimals === 0 ? `${numero},${'0'.repeat(precision)}` : numero + '0'.repeat(precision - decimals);
//     // numero + ',' + '0'.repeat(precision) : numero + '0'.repeat(precision - decimals);
//   }

//   if (a.toString().length === 4) {
//     numero = numero.replaceAll(a, b);
//   }

//   if (numero.indexOf('NaN') > -1) {
//     numero = '0,00';
//   }

//   return numero.toString();
// }
export function formatearMiles(entrada) {
  return entrada.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

export const formatearNumeroEspPrecision = (numeroParametro, precision) => {
  let numero = numeroParametro;
  const a = parseInt(numero, 10);
  console.log(a);
  const b = formatearMiles(a);
  numero = new Intl.NumberFormat('es-ES').format(parseFloat(numero).toFixed(precision));
  if (precision > 0) {
    const decimals = numero.indexOf(',') > -1 ? numero.length - 1 - numero.indexOf(',') : 0;
    numero = decimals === 0 ? `${numero},${'0'.repeat(precision)}` : numero + '0'.repeat(precision - decimals);
    // numero + ',' + '0'.repeat(precision) : numero + '0'.repeat(precision - decimals);
  }

  if (a.toString().length === 4) {
    numero = numero.replaceAll(a, b);
  }

  if (numero.indexOf('NaN') > -1) {
    numero = '0,00';
  }

  return numero.toString();
};
